import React from 'react';

import classes from './CurriculumQuizContent.module.css';

import AddIcon from '../../../assets/icons/icon-plus-blue.svg';
import Accordion from '../../UI/Accordion/Accordion';
import { IsListEmpty, IsObjectEmpty } from '../../../utilities/CommonMethods';
import AddNewQuizQuestionForm from '../../Forms/QuizQuestionForm/QuizQuestionForm';
import AssignmentQuizDetailsSection from '../AssignmentQuizDetailsSection/AssignmentQuizDetailsSection';
import ResourceAPIController from '../../../webServices/ResourceAPIController';
import ShowLoader from "../../../hoc/ShowLoader/ShowLoader";

class CurriculumQuizContent extends React.Component {

    state = {
        quizProblems: [],
        collapseAll: true,
        showQuizLoader: true,
        showAddNewQuestionForm: false,
        showEditQuizPopup: false,
        showContentLoader: null
    }

    collapseAllProblemsClick = () => {
        const updatedState = this.state.collapseAll;
        this.setState({ collapseAll: !updatedState });
    }

    onAddNewQuestionClick = () => {
        this.setState({ showAddNewQuestionForm: true });
    }

    hideAddNewQuizQuestionForm = () => {
        this.setState({ showAddNewQuestionForm: false });
    }

    showEditQuizPopup = () => {
        this.setState({ showEditQuizPopup: true });
    }

    hideEditQuizPopup = () => {
        this.setState({ showEditQuizPopup: false });
    }

    addNewQuizQuesitonClicked = (questionData) => {
        this.setState({ showContentLoader: true });

        let responseObj = null;
        ResourceAPIController.addNewQuizQuestion(this.props.topicData.topicId, questionData)
            .then(response => {
                responseObj = response.result;
                // console.log('Add New Quiz Question Data => ', responseObj);
                let updatedQuestionsList = [...this.state.quizProblems];
                updatedQuestionsList.push(responseObj[0]);

                this.setState({ showContentLoader: false, showAddNewQuestionForm: false, quizProblems: updatedQuestionsList });
                this.props.getQuizDetails(this.props.data.quizResult.topicId);
                this.props.onSuccessDialogShow('Question added successfully.', 'OKAY');

            })
            .catch(err => {
                console.log('Add New Quiz Question error => ', err)
                this.setState({ showContentLoader: false });
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                } else {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
            });
    }

    editQuizQuesitonClicked = (problemId, questionData, pos) => {
        this.setState({ showContentLoader: true });

        let responseObj = null;
        ResourceAPIController.updateQuizQuestion(problemId, questionData)
            .then(response => {
                responseObj = response.result;
                // console.log('Edit Quiz Question Data => ', responseObj)
                let updatedProblemsList = [...this.state.quizProblems];
                updatedProblemsList[pos] = responseObj[0];

                this.setState({ showContentLoader: false, quizProblems: updatedProblemsList });
                this.props.getQuizDetails(this.props.data.quizResult.topicId);
                this.props.onSuccessDialogShow('Question updated successfully.', 'OKAY');

            })
            .catch(err => {
                console.log('Edit Quiz Question error => ', err)
                this.setState({ showContentLoader: false });
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                } else {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
            });
    }

    onEditProblemClick = (problemId, pos) => {
        // alert('Edit Problem => ' + problemId + ' ' + pos);
        let updatedProblemsList = [...this.state.quizProblems];
        updatedProblemsList[pos].showEditForm = true;

        this.setState({ quizProblems: updatedProblemsList });
    }

    onDeleteQuizProblemIconClick = (event, problemId, pos) => {
        event.stopPropagation();
        this.props.showConfirmationDialog(problemId, (pos + 1));
    }

    hideEditForm = (pos) => {
        // alert('Clicked hide edit form ' + pos);
        let updatedProblemsList = [...this.state.quizProblems];
        updatedProblemsList[pos].showEditForm = false;

        this.setState({ quizProblems: updatedProblemsList });
    }


    componentDidMount() {
        if (!IsObjectEmpty(this.props.data) && !IsListEmpty(this.props.data.quizProblems)) {
            this.setState({ quizProblems: this.props.data.quizProblems });
        }
    }

    componentDidUpdate(prevProps) {
        if (IsObjectEmpty(prevProps.data) && !IsObjectEmpty(this.props.data) && (prevProps.data.quizProblems !== this.props.data.quizProblems)) {
            this.setState({ quizProblems: this.props.data.quizProblems });
        }
    }

    render() {

        return (
            <div className={classes.CurriculumQuizContent}>
                <AssignmentQuizDetailsSection
                    forPMPage={this.props.forPMPage}
                    batchCode={this.props.batchCode}
                    moduleName={this.props.moduleName}
                    data={this.props.data}
                    result={this.props.data.quizResult}
                    type="Quiz"
                    showEditQuizPopup={this.props.showEditQuizPopup}
                />

                <div className={classes.ProblemsSection}>
                    <p className={classes.CardHeading}>Quiz Problems</p>
                    <p className={[classes.TextLink, classes.AlignRight].join(' ')} onClick={this.collapseAllProblemsClick}>
                        {!IsListEmpty(this.state.quizProblems)
                            ? this.state.collapseAll ? 'EXPAND ALL' : 'COLLAPSE ALL' : null}
                    </p>


                    <div className={classes.ProblemsContainer}>
                        <Accordion
                            forPMPage={this.props.forPMPage}
                            data={this.state.quizProblems}
                            collapseAll={this.state.collapseAll}
                            forInstructor={true}
                            onEditProblemClick={this.onEditProblemClick}
                            onDeleteProblemClick={this.onDeleteQuizProblemIconClick}
                            hideEditForm={this.hideEditForm}
                            editQuizQuesitonClicked={this.editQuizQuesitonClicked}
                            showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                            redirectToUnauthorized={this.props.redirectToUnauthorized}
                            onFailureDialogShow={this.props.onFailureDialogShow}
                            showContentLoader={this.state.showContentLoader}
                        />
                    </div>


                </div>

                {
                    this.state.showAddNewQuestionForm
                        ? <div className={classes.AddNewQuestionFormContainer} >
                            <AddNewQuizQuestionForm
                                hideForm={this.hideAddNewQuizQuestionForm}
                                addNewQuizQuesitonClicked={this.addNewQuizQuesitonClicked}
                                showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                                redirectToUnauthorized={this.props.redirectToUnauthorized}
                                onFailureDialogShow={this.props.onFailureDialogShow}
                                showContentLoader={this.state.showContentLoader} />
                        </div>
                        : <div className={classes.AddNewQuestionDiv} onClick={this.onAddNewQuestionClick}>
                            <img src={AddIcon} alt="Add New Quiz-Assignment Question Icon" className={classes.AddIcon} />
                            Add New Question
                        </div>
                }</div>
        );
    }
}

export default CurriculumQuizContent;